import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks.ts";

interface Props {
  children: React.ReactNode;
}

export const AdminMiddleware: React.FC<Props> = ({ children }) => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const isAuthorized = userInfo?.groups.includes("admin");

  return <>{isAuthorized ? children : <Navigate to="/auth/login" />}</>;
};
